<template>
  <section class="bg-white">
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag type="primary" outline size="small" class="mr-2" v-if="this.catNm">
            {{ catNm }}
          </Tag>
          <div class="menu-id" v-if="bindData && bindData.menuInformation">
            メニューNo. {{ bindData.menuInformation.menuNo }}
          </div>
        </div>
        <div class="header-right">
          <Share />
        </div>
      </div>
      <div class="title-bold" v-if="!showMenuNm">
        {{ bindData.planBasicInfo.planNm }}
      </div>
      <h2 class="menu-title two-lines-ellipsis" v-if="menuNm">
        {{ menuNm | capitalize }}
      </h2>
      <div class="header-meta">
        <div class="meta-item inline-flex mr-2" v-if="areaMidClassNm || areaDtlClassNm">
          <i class="icon icon-bor-pin pt-1 pr-2" />
          <span>{{areaMidClassNm}} <span v-if="areaMidClassNm && areaDtlClassNm"> > </span> {{areaDtlClassNm}}</span>
        </div>
        <button class="c-btn btn-white btn-sm" v-if="longitude && latitude" @click="gotoMap">
          地図を見る
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Tag from '../../primitive/Tag'
import _ from 'lodash'
import { SAVE_FAVORITE, GET_STATUS_FAVORITE, DELETE_FAVORITE } from '@/store/modules/bs_myp/actions'

export default {
  name: 'SubHeaderMenu',
  components: {
    Tag
  },
  props: ['value', 'showMenuNm'],
  data() {
    return {
      areaMidClassNm: '',
      areaDtlClassNm: '',
      latitude: '',
      longitude: '',
      showPopup: false,
      statusFavorite: false,
      catNm: '',
      menuNm: '',
      bindData: {}
    }
  },
  created() {
    if (this.value) {
      this.bindData = this.value
      if(this.showMenuNm === null) {
        this.showMenuNm = false
      }
    }
  },
  mounted() {
    const {menuNo, planId, roomId} = this.$route.params
    if (this.title === null || this.title === '') {
      this.title = '宿泊施設名宿泊施設名宿泊施設名宿泊施設名宿泊施設名宿泊施設名'
    }
    if (this.bindData) {
      this.$repositories('plan').getPlanDetail(menuNo, planId, roomId).then(
        (data) => {
          if (data) {
            this.bindData = data
            this.areaMidClassNm = _.get(data, 'menuInformation.areaInfomation.areaMidClassNm', null)
            this.areaDtlClassNm = _.get(data, 'menuInformation.areaInfomation.areaDtlClassNm', null)
            this.longitude = _.get(data, 'menuInformation.areaInfomation.longitude', null)
            this.latitude = _.get(data, 'menuInformation.areaInfomation.latitude', null)
            this.menuNm = _.get(this.bindData, 'menuInformation.menuNm', '')
            this.getCatNm()
          }
        }
      )
    }
    this.getStatusFavorite()
  },
  computed: {
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    }
  },
  watch: {
    // value(val) {
    //   this.bindData = val
    // },
    bindData: {
      deep: true,
      handler() {
        
      }
    }
  },
  methods: {
    gotoMap() {
      if (this.latitude !== null && this.longitude !== null) {
        window.open(`https://maps.google.com/?q=${this.latitude},${this.longitude}`)
        return
      }
      window.open('https://maps.google.com')
    },
    checkLogin() {
      const query = this.$route.query
      const data = {
        itemType: 'favourite', 
        menuNo: query.menuNo
      }

      if(this.statusFavorite) {
        this.$store.dispatch(DELETE_FAVORITE, this.idFavorite).then(
          () => {
            this.statusFavorite = false
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      } else {
        this.$store.dispatch(SAVE_FAVORITE, data).then(
          (result) => {
            this.idFavorite = _.get(result, 'id', '')
            this.statusFavorite = true
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      }
    },
    getStatusFavorite() {
      const query = this.$route.query
      const params = {
        menuNo: query.menuNo
      }
      this.$store.dispatch(GET_STATUS_FAVORITE, params).then(
        (data) => {
          if (data) {
            this.statusFavorite = _.get(data, 'data.favourite', '')
            this.idFavorite = _.get(data, 'data.id', '')
          }
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    },
    getCatNm() {
      const dataCatNm = _.get(this.bindData, 'menuInformation.categoryInfomation', '')
      this.catLrgClassNm = _.get(dataCatNm, 'catLrgClassNm', '')
      this.catMidClassNm = _.get(dataCatNm, 'catMidClassNm', '')
      this.catSmlClassNm = _.get(dataCatNm, 'catSmlClassNm', '')
      if(this.catLrgClassNm === '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catSmlClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        this.catNm = `${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${ this.catLrgClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catLrgClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        this.catNm = `${this.catLrgClassNm  }・${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catLrgClassNm  }・${  this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
